
  import { Vue, Component, Prop } from "vue-property-decorator";

  import DELETE_NOTIFICATIONS from "@/apollo/notifications/DeleteNotifications.gql";

  import UIButton from "@/components/button/ui-button.vue";

  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";

  @Component({
    components: {
      UIButton,
    },
  })
  export default class DeleteReadNotifications extends Vue {
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: Boolean, default: false }) readonly processing!: boolean;

    async deleteReadNotifications(): Promise<void> {
      this.$confirm({
        title: `Delete read notifications`,
        message: `Do you really want to delete notifications that are marked as read`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm: any) => {
          if (confirm) {
            this.$emit("update:processing", true);

            await this.deleteNotificationsMutation();
            this.$emit("completed");
          }
        },
      });
    }

    private async deleteNotificationsMutation(): Promise<void> {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_NOTIFICATIONS,
          variables: {
            where: {
              _and: [
                {
                  user_id: { _eq: this.currentUserId },
                },
                { read: { _eq: true } },
              ],
            },
          },
        });
      } catch (e) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
      } finally {
        this.$emit("update:processing", false);
      }
    }
  }
